export const europeanConstant = {
    european_REQUEST: "european_REQUEST",
    european_SUCCESS: "european_SUCCESS",
    european_FAILURE: "european_FAILURE",

    GET_INSURANCEDESCRIPTION_REQUEST: "GET_INSURANCEDESCRIPTION_REQUEST",
    GET_INSURANCEDESCRIPTION_SUCCESS: "GET_INSURANCEDESCRIPTION_SUCCESS",
    GET_INSURANCEDESCRIPTION_FAILURE: "GET_INSURANCEDESCRIPTION_FAILURE",
}
